<template>
  <div>
    <!-- HERO -->
    <section class="hero">
      <div class="hero__overlay"></div>
      <header class="header">
        <AppLogo asLink to="/" size="md" :showText="true" />
      </header>
    </section>

    <!-- 메인 카드 -->
    <main class="main">
      <div class="container">
        <div class="card nf-card">
          <div class="nf-inner">
            <div class="nf-head">
              <div class="nf-badge">오류</div>
              <h1 class="nf-title">404 – 페이지를 찾을 수 없습니다</h1>
              <p class="nf-desc">
                요청하신 주소가 변경되었거나 삭제되었을 수 있어요.
              </p>
            </div>

            <div class="nf-actions">
              <UiButton variant="brand" @click="$router.replace('/')"
                >홈으로</UiButton
              >
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import AppLogo from "@/components/AppLogo.vue";
import UiButton from "@/components/UiButton.vue";

export default {
  name: "NotFoundView",
  components: { AppLogo, UiButton },
  mounted() {
    document.title = "404 | Cardio Factory";
  },
};
</script>

<style scoped>
.nf-card {
  max-width: 758px;
  margin: 0 auto;
  padding: 48px 56px;
  background: #151718;
  border-radius: 30px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.35);
}
.nf-inner {
  max-width: 520px;
  margin: 0 auto;
  text-align: left;
}
.nf-head {
  margin-bottom: 24px;
}
.nf-badge {
  color: #78ff47;
  font-size: 18px;
  letter-spacing: -0.01em;
}
.nf-title {
  margin: 6px 0 8px;
  font-weight: 700;
  font-size: 32px;
  letter-spacing: -1.2px;
}
.nf-desc {
  color: rgba(255, 255, 255, 0.75);
}

.nf-actions {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 16px;
}
.link-btn {
  background: transparent;
  border: 0;
  color: rgba(255, 255, 255, 0.85);
  cursor: pointer;
  text-decoration: underline;
}

/* UiInput 룩앤필과 일치하는 버튼 폭이 필요하면 아래처럼 변경 가능
  .nf-actions :deep(.ui-btn) { min-width: 140px; }
  */
.footer-bar {
  width: 100%;
  margin: 0;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
  background: #151718;
}
</style>
